import CompraDFeManifestoService from "@/services/CompraDFeManifestoService";

export const compraDFeManifesto = {
  namespaced: true,
  state: {
    compraDFeManifesto: {},
  },
  actions: {
    manifestarDocumento({ commit }, payload) {
      return CompraDFeManifestoService.ManifestarDocumento(payload).then(
        (compraDFeManifesto) => {
          return Promise.resolve(compraDFeManifesto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    obterNotas({ commit }, payload) {
      return CompraDFeManifestoService.ObterNotas(payload).then(
        (compraDFeManifesto) => {
          return Promise.resolve(compraDFeManifesto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    obterCTe({ commit }, payload) {
      return CompraDFeManifestoService.ObterCTe(payload).then(
        (compraDFeManifesto) => {
          return Promise.resolve(compraDFeManifesto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    baixarXML({ commit }, payload) {
      return CompraDFeManifestoService.BaixarXML(payload).then(
        (compraDFeManifesto) => {
          return Promise.resolve(compraDFeManifesto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    imprimirNFe({ commit }, payload) {
      return CompraDFeManifestoService.ImprimirNFe(payload).then(
        (compraDFeManifesto) => {
          return Promise.resolve(compraDFeManifesto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCompraDFeManifesto({ commit }, payload) {
      return CompraDFeManifestoService.GetCompraDFeManifesto(payload).then(
        (compraDFeManifesto) => {
          return Promise.resolve(compraDFeManifesto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCompraDFeManifesto({ commit }, payload) {
      return CompraDFeManifestoService.PostCompraDFeManifesto(payload).then(
        (compraDFeManifesto) => {
          return Promise.resolve(compraDFeManifesto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCompraDFeManifesto({ commit }, payload) {
      return CompraDFeManifestoService.PutCompraDFeManifesto(payload).then(
        (compraDFeManifesto) => {
          return Promise.resolve(compraDFeManifesto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCompraDFeManifesto({ commit }, payload) {
      return CompraDFeManifestoService.DeleteCompraDFeManifesto(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCompraDFeManifestoOData({ commit }, payload) {
      return CompraDFeManifestoService.GetCompraDFeManifestoOData(payload).then(
        (compraDFeManifesto) => {
          return Promise.resolve(compraDFeManifesto);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default compraDFeManifesto;
